import ListingsCategory from '../ListingsCategory';


const ShopAllDropDownHeaders = ["Households", "More Households", "Real Estate", "Skilled Tech", "Pets"];


const getListingsArray = (retrieveCategory) => {
  if(typeof retrieveCategory === "string"){
    const getUnitSection = ListingsCategory.filter(data => data.category === retrieveCategory);
    return getUnitSection[0].options;
  }else{
    return [];
  };
};

const HouseHolds = getListingsArray("House-Holds");
const MoreHouseHolds = getListingsArray("More-HouseHolds");
const RealEstate = getListingsArray("Real-Estate");
const SkilledLabour = getListingsArray("Skilled-Labour");
const Pets = getListingsArray("Pet");


const arrangeItems = () => {
  const bucketItems = [];
  for(let i=0; i<HouseHolds.length; i++){
    bucketItems.push(HouseHolds[i]);
    bucketItems.push(MoreHouseHolds[i]);
    bucketItems.push(RealEstate[i]);
    bucketItems.push(SkilledLabour[i]);
    bucketItems.push(Pets[i]);
  };
  return bucketItems;
};

const validateArray = (...a) => {
  let getFalsyCount = 0;
  const getArguments = [...a];
  for(let i=0; i<getArguments.length; i++){
    Array.isArray(getArguments[i]) === false ? getFalsyCount += 1 : getFalsyCount += 0;
  }
  if(getFalsyCount > 0){
    return false;
  }else{
    return true;
  };
};


const getMaxArray = (...a) => {
  let theMaxArray = [];
  const jointArrays = [...a];
  for(let i=0; i<jointArrays.length; i++){
    if(jointArrays[i].length > theMaxArray.length){
      theMaxArray = jointArrays[i];
    };
  };
  return theMaxArray;
};

const getMaxArrayLength = (...a) => {
  let theMaxArray = [];
  const jointArrays = [...a];
  for(let i=0; i<jointArrays.length; i++){
    if(jointArrays[i].length > theMaxArray.length){
      theMaxArray = jointArrays[i];
    };
  };
  return theMaxArray.length;
};


const cleanOutput = (args) => {
  const getClean = [];
  for(let i=0; i<args.length; i++){
    if(typeof args[i] === 'undefined' || typeof args[i] === undefined){
      getClean.push('');
    }else{
      getClean.push(args[i]);
    };
  };
  return getClean;
};

const splitArray = (a, b, c, d, e) => {
  let maxArrayLength = getMaxArrayLength(a,b,c, d, e);
  const rearrange = [];
  for(let i=0; i<maxArrayLength; i++){
    rearrange.push(cleanOutput([a[i], b[i], c[i], d[i], e[i]]));
  }
  return rearrange;
};


export {
  ShopAllDropDownHeaders, HouseHolds, MoreHouseHolds, 
  RealEstate, SkilledLabour, Pets, arrangeItems, splitArray,
};